import { createURLWithTokenAndCustomPath, restPost } from '~/src/dash/api/rest';

export enum ForecastType {
  Unknown = 0,
  LineItem,
  Inventory,
  Audience,
}

export enum ForecastEvent {
  Unknown = 0,
  Run,
  Email,
}

export interface IForecastUsageAnalytic {
  UserID: string;
  PublisherID: string;
  ForecastTargetID?: string;
  ForecastType: ForecastType;
  ForecastEvent: ForecastEvent;

  ChannelIDs?: string;
  ChannelGroupIDs?: string;
  BidderIDs?: string;
  StartDate?: string;
  EndDate?: string;
  Timezone?: string;

  // line item targeting that's supports a value
  Dayparting?: string;
  TargetingLivestream?: string; // pbapi.AdserverCampaign_TargetingLiveStream
  TargetingLimitedAdTracking?: string;
  TargetingCCPA?: string; // pbapi.GeneralTargetingCCPA
  TargetingRequestedPodDurationMin?: number;
  TargetingRequestedPodDurationMax?: number;

  // line item targeting that supports a list
  TargetingDevices?: string;
  TargetingDeviceTypes?: string;
  TargetingDeviceSubTypes?: string;
  TargetingAppBundleIDs?: string;
  TargetingContentChannels?: string;
  TargetingContentDistributors?: string;
  TargetingContentGenres?: string;
  TargetingContentIDs?: string;
  TargetingContentNetworks?: string;
  TargetingContentProducers?: string;
  TargetingContentRatings?: string;
  TargetingContentSeries?: string;
  TargetingContentTitles?: string;
  TargetingSitePages?: string;
  TargetingCountries?: string;
  TargetingDmasAllowed?: string;
  TargetingZipsAllowed?: string;
  TargetingCitiesAllowed?: string;
  TargetingStatesAllowed?: string;
  TargetingDmasDisallowed?: string;
  TargetingZipsDisallowed?: string;
  TargetingCitiesDisallowed?: string;
  TargetingStatesDisallowed?: string;
}

export async function createForecastUsageAnalytic(
  forecastUsageAnalytic: IForecastUsageAnalytic,
  publisherID: string,
): Promise<[IForecastUsageAnalytic | undefined, string | undefined]> {
  const reqUrl = createURLWithTokenAndCustomPath(
    `/settings/publisher/${publisherID}/forecast_usage_analytic`,
  );

  try {
    return [
      (await restPost<IForecastUsageAnalytic>(reqUrl, forecastUsageAnalytic)).parsedBody,
      undefined,
    ];
  } catch (e) {
    return [undefined, e];
  }
}
